<div class="container mt-5">
    <div class="row justify-content-center">
        <div class="col-sm-12 col-md-8 col-lg-6">
            <!-- REPORT TITLE  -->
            <h2 class="mb-3">{{'reportsWizard.header.reportOf' | translate }} {{report.reportData.name}}</h2>

            <!-- GO BACK BUTTON -->
            <button type="button" class="btn btn-secondary mb-3" (click)="goBack()">
                <i class="pi pi-arrow-left"></i>
                {{ 'reportsWizard.reportsForm.goBack' | translate }}
            </button>

            <form [formGroup]="reportForm" (ngSubmit)="onSubmit()" class="p-3 border rounded">
                <!-- Delegation field -->
                <div class="mb-3">
                    <label for="delegation">{{'tableManagement.delegations.delegation' | translate}}</label>

                    <p-multiSelect [options]="delegations" [(ngModel)]="selectedDelegations"
                        formControlName="delegation" optionLabel="codeName" class="ms-3"
                        placeholder="{{'general.select' | translate}} {{'tableManagement.delegations.delegation' | translate}}"
                        [showClear]="true">
                        <ng-template let-item pTemplate="option">
                            <div class="delegation-option">
                                ({{ item.code }}) {{ item.name }}
                            </div>
                        </ng-template>
                    </p-multiSelect>
                </div>
            </form>

            <!-- SUBMIT BUTTON -->
            <button type="submit" pButton (click)="toPhase3()"
                [disabled]="!reportForm.valid"
                class="btn btn-primary mt-3 w-100"
                [ngStyle]="{'background-color': '#C42C22', 'border-color': '#C42C22'}">{{ 'reportsWizard.reportsForm.next' | translate }}</button>
        </div>
    </div>
</div>